export default __webpack_public_path__ + "static/media/barn.f2b7082f.webp";